import axios from 'axios'

export default () => {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('vue-token')
    }
  });
  
  return instance;
}